<script>
    import {user} from "./sessionStore"
    import {supabase} from "./supabaseClient"
    import Auth from "./Auth.svelte"
    import Profile from "./Profile.svelte"
    import Views from "./Views.svelte";
	import { Router, Route } from "svelte-routing";
    

    user.set(supabase.auth.user())

    supabase.auth.onAuthStateChange((_, session) => {
        user.set(session.user)
    })
</script>

<Router>
    <span>
        {#if $user}
            <Route path="bookmarks/add">
                <Views view="bookmarks"/>
            </Route>
            <Route path="bookmarks">
                <Views view="bookmarks"/>
            </Route>
            <Route path="excerpts">
                <Views view="excerpts"/>
            </Route>

            <!-- Default -->
            <Route>
                <Views view="excerpts"/>
            </Route>
        {:else}
            <!-- Default -->
            <Route>
                <Auth/>
            </Route>
        {/if}
    </span>
</Router>
